/**
 * Configuration module
 *
 * Priority (highest to lowest):
 * 1. Runtime config.js (injected by Caddy in production)
 * 2. Vite environment variables (from .env files)
 * 3. Fallback to current domain
 */

// Extend Window interface for runtime config
declare global {
  interface Window {
    apiRoot?: string;
  }
}

// Check if runtime config was loaded (from /runtime/config.js via script tag in index.html)
// This will be available in production when served by Caddy
const runtimeApiRoot = typeof window !== 'undefined' && window.apiRoot;

// Use Vite's environment variable as fallback
const envApiRoot = import.meta.env.VITE_API_ROOT as string | undefined;

// Final fallback: use current origin (works for same-origin API)
const fallbackApiRoot = typeof window !== 'undefined' ? window.location.origin : '';

// Export the apiRoot with priority order
export const apiRoot: string = runtimeApiRoot || envApiRoot || fallbackApiRoot;

// Log the configuration in development
if (import.meta.env.DEV) {
  console.log('API Configuration:', {
    runtimeApiRoot,
    envApiRoot,
    fallbackApiRoot,
    using: apiRoot,
  });
}

// Make it globally available for backward compatibility (if needed)
if (typeof window !== 'undefined') {
  window.apiRoot = apiRoot;
}
